'use client'

import { createContext, useContext } from 'react'
import type { Locale } from './config'
import type { Dictionary } from './dictionaries'
import { getDictionary } from './dictionaries'

interface I18nContextType {
  locale: Locale
  t: Dictionary
}

const I18nContext = createContext<I18nContextType>({
  locale: 'fr',
  t: getDictionary('fr'),
})

export function I18nProvider({
  locale,
  children,
}: {
  locale: Locale
  children: React.ReactNode
}) {
  const t = getDictionary(locale)
  return (
    <I18nContext.Provider value={{ locale, t }}>
      {children}
    </I18nContext.Provider>
  )
}

export function useI18n() {
  return useContext(I18nContext)
}

export function useTranslation() {
  const { t } = useContext(I18nContext)
  return t
}
